// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1.04492V11H22.9552C22.4796 5.7229 18.2771 1.52047 13 1.04492Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 1.04492V13H22.9552C22.45 18.6065 17.7381 23.0001 12 23.0001C5.92487 23.0001 1 18.0752 1 12.0001C1 6.26204 5.3935 1.55015 11 1.04492Z"}}]};

const ChartPieFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-pie-filled',
    ref,
    icon: element,
  },
));

ChartPieFilledIcon.displayName = 'ChartPieFilledIcon';

export default ChartPieFilledIcon;
